import { SelectionMarkerIcon } from './SelectionMarkerIcon';

/**
 * author: Austin Andrews
 * id DA670815-123E-4443-B813-5BB4A556AB1C
 * name selection-marker
 * version: 4.7.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/selection-marker.svg
 * tags
 * - Navigation 
 */
export const SelectionLocationIcon = SelectionMarkerIcon;
export default SelectionLocationIcon